import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import CelebrationIcon from "@mui/icons-material/Celebration";
import { Fab, Grid, Tooltip } from "@mui/material";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  updateAnniversariesDrawer,
  updateNotesDrawer,
} from "../../../slice/dashboard";
import CurrentWeeksInstruction from "../../CurrentWeekInstruction/component/currentWeeksInstruction";
import NotesDrawer from "../../Notes/notesDrawer";
import ThingsToDo from "../../ThingsToDo/components/thingsToDo";
import AnniversariesDrawer from "../../Anniversaries/AnniversariesDrawer";
import NewThingsToDo from "../../ThingsToDo/components/NewThingsToDo";

const Dashboard = () => {
  const dispatch = useDispatch();
  const { isNote, isAnniversaryDrawer } = useSelector(
    (state) => state?.dashboard
  );
  return (
    <>
      {/* Tasks Comments Drawer */}
      {isNote && (
        <NotesDrawer
          open={isNote}
          handleClose={() => dispatch(updateNotesDrawer())}
        />
      )}
      {/* Anniversaries Drawer */}
      {isAnniversaryDrawer && (
        <AnniversariesDrawer
          open={isAnniversaryDrawer}
          handleClose={() => dispatch(updateAnniversariesDrawer())}
        />
      )}

      <Grid container height={`${window.innerHeight - 10}px`} padding={1}>
        {/* Anniversaries Icon */}
        <Tooltip title="Anniversaries">
          <Fab
            color="primary"
            aria-label="add"
            style={{
              position: "absolute",
              top: "40%",
              right: 1,
              backgroundColor: "#00ce3f",
              borderBottomLeftRadius: "20px",
              borderTopLeftRadius: "20px",
              borderTopRightRadius: "0px",
              borderBottomRightRadius: "0px",
            }}
            size="small"
            onClick={() => dispatch(updateAnniversariesDrawer())}
          >
            <CelebrationIcon />
          </Fab>
        </Tooltip>

        {/* Notes Icon */}
        <Tooltip title="Notes">
          <Fab
            color="primary"
            aria-label="add"
            style={{
              position: "absolute",
              top: "50%",
              right: 1,
              backgroundColor: "#00ce3f",
              borderBottomLeftRadius: "20px",
              borderTopLeftRadius: "20px",
              borderTopRightRadius: "0px",
              borderBottomRightRadius: "0px",
            }}
            size="small"
            onClick={() => dispatch(updateNotesDrawer())}
          >
            <NotificationsActiveIcon />
          </Fab>
        </Tooltip>
        <Grid
          item
          xs={0}
          display={"flex"}
          flexDirection={"row"}
          padding={2}
          boxSizing={"border-box"}
          margin={0}
          overflow={"hidden"}
          maxHeight={"98vh"}
          style={{ width: "100%" }}
        >
          {/* Grid Section for things to do */}
          <Grid
            xs={8.5}
            display={"flex"}
            flexDirection={"column"}
            pr={2}
            className="dashboard-scrollbar"
            height="100vh"
          >
            {/* <ThingsToDo /> */}
            {/* FORWORKFLOW  */}
            <NewThingsToDo />
          </Grid>
          {/* Grid Section for New Instructions (Current Week) */}
          <Grid item xs={3.5} pl={1} maxHeight={"90vh"}>
            <CurrentWeeksInstruction />
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default Dashboard;
